import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import i18n from 'i18next';
import withStyles from 'react-jss';
import { map } from 'lodash';
import { useTranslation } from 'react-i18next';
import { sectionClassMapping } from '../ModalCompare.js';
import FuzzySearchBar from '../../../career-search/FuzzySearchBar';
import { getTenantState } from '../../../../store/selectors';
import CompareCareersSection from './CompareCareersSection';
import Loading from '../../Loading';
import { getLocalizedPropValue } from '../../../../util/localization';
const sectionList = ['Favorites', 'Top 25', 'All Careers'];

const careerTextStyles = {
  titleColor: () => ({
    color: '#6a6a6a',
  }),
  careerTextColor: (props) => ({
    color: props.tenant.primary,
  }),
};

function CompareCareers(props) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [filtered, setFiltered] = useState([]);
  const [mainSections, setMainSections] = useState(true);
  const [careerList, setCareerList] = useState([]);

  const getCareerList = async () => {
    const listRaw = await props.getCareerList(props.tenant.id);
    const list = listRaw.map((career) => ({
      ...career,
      // for now, 'titleEn' will actually contain the translated title in the current language
      titleEn: getLocalizedPropValue(career, 'title', i18n.language),
      description: getLocalizedPropValue(career, 'description', i18n.language),
      tasks: getLocalizedPropValue(career, 'tasks', i18n.language),
    }));
    setCareerList(list);
    setLoading(false);
  };

  useEffect(() => {
    getCareerList();
  }, []);

  const dynamicCareersColor = props.classes.careerTextColor;
  const dynamicTitleTextColor = props.classes.titleColor;

  // Create the filtered list of careers
  const sendFilteredListToParent = async (val) => {
    setFiltered(val);
  };

  // allow the FuzzySearchBar to change loading so that the spinner is shown while searching
  const setCareerListLoadingOnParent = (bool) => {
    setMainSections(bool);
    setLoading(bool);
  };

  const getCareerListForSection = (section) => {
    // Get the user's top 25 careers
    switch (section) {
      case 'Top 25':
        return props.careerGameResults;
      // TODO: When we have the 'Favorites' list in place, put it here
      case 'Favorites':
        return props.favorites;
      // Get the all the careers for this tenant
      case 'All Careers':
        return careerList;
      default:
        return [];
    }
  };

  const careerListPerSection = () => {
    return sectionList.reduce(
      (obj, section) => ({
        ...obj,
        [section]: getCareerListForSection(section),
      }),
      {}
    );
  };

  const checkMainSectionsDisplay = async () => {
    await props.showCompareCareersSearchBar();
  };

  // Create the 3 main sections
  const getMainSections = () => {
    return map(careerListPerSection(), (listOfCareers, sectionName, lists) => {
      const index = Object.keys(lists).indexOf(sectionName);

      if (!listOfCareers || listOfCareers.length === 0) return null;

      return (
        <CompareCareersSection
          dynamicTitleTextColor={dynamicTitleTextColor}
          dynamicCareersColor={dynamicCareersColor}
          dynamicSectionClass={sectionClassMapping[sectionName]}
          dynamicSectionTitle={sectionName}
          key={sectionName}
          checkMainSectionsDisplay={checkMainSectionsDisplay}
          section={sectionName}
          careerList={listOfCareers}
          addLine={index < sectionList.length - 1}
        />
      );
    });
  };

  return (
    <div id="compare-page">
      <FuzzySearchBar
        inputText={t('Search Careers')}
        tenant={props.tenant}
        listToSearch={careerList}
        sendFilteredListToParent={sendFilteredListToParent}
        setSearchListLoadingOnParent={setCareerListLoadingOnParent}
      />
      {/* Is the user actively searching or should we display just the 3 sections? */}
      {loading ? (
        <Loading height="100%" />
      ) : (
        <>
          {!mainSections ? (
            <CompareCareersSection
              dynamicTitleTextColor={dynamicTitleTextColor}
              dynamicCareersColor={dynamicCareersColor}
              careerList={filtered}
              dynamicSectionTitle="All Careers"
              checkMainSectionsDisplay={checkMainSectionsDisplay}
              dynamicSectionClass={sectionClassMapping['Searching Careers...']}
              setMainSections={setMainSections}
            />
          ) : (
            <div className="career-list-modal-container">
              {getMainSections()}
            </div>
          )}
        </>
      )}
    </div>
  );
}

function mapStateToProps(state) {
  const tenant = getTenantState(state);

  return { tenant };
}

export default connect(
  mapStateToProps,
  {}
)(withStyles(careerTextStyles)(CompareCareers));
